module.exports = __webpack_public_path__ + "img/complete.db181fc6.svg";